export function utilsScrollTop(top = 0, behavior?: 'instant' | 'smooth'): void {
  if (import.meta.browser) nextTick(() => window.scroll({ top, left: 0, behavior: behavior || 'smooth' }))
}

export function scrollToElem(
  elem2: HTMLElement | None,
  options?: { offsetTop?: number; tolarance?: number; behavior?: 'instant' | 'smooth' },
): void {
  const elem = helpers.getHTMLElement(elem2)
  if (!elem || !('getBoundingClientRect' in elem)) return
  const { behavior, offsetTop = 0, tolarance = 0 } = options || {}
  const top = elem.getBoundingClientRect().top + myWindow('scrollTop', 0) - offsetTop
  if (Math.abs(top - myWindow('scrollTop', 0)) < tolarance) return
  utilsScrollTop(top, behavior)
}
